export default class DashboardCtrl{

  static $resolve = {
    typyPoziadavky: (TypPoziadavkyService) => TypPoziadavkyService.list(),
    otvorenePoziadavky: (PoziadavkaService) => PoziadavkaService.list({own: true, stav: -1}).then(r => r.result)
  }

  constructor(AuthService, typyPoziadavky, otvorenePoziadavky){
      this.AuthService = AuthService;
      this.typyPoziadavky = typyPoziadavky.filter(typ => typ.externy);
      this.otvorenePoziadavky = otvorenePoziadavky;
  }

}


// WEBPACK FOOTER //
// ./src/customer-portal/dashboard/DashboardCtrl.js